<template>
  <div class="header">
    <div class="header-title">
      <span class="transition-box"
        ><span ref="title" style="margin-left: 30px">{{
          projectName
        }}</span></span
      >
    </div>
    <div class="header-admin">
      <span class="user-info">您好！{{ accountName }}</span>
      <span class="data-time">{{ datatime }}</span>

      <el-tooltip
          class="item"
          effect="dark"
          :enterable="false"
          content="导游机跳转"
          placement="top"
        >
          <span style="position: relative;" v-if="voiceguideParamConfig.script">
            <img style="display: flex;width: 20px;height: 20px;margin-left: 20px;border-radius: none;cursor: pointer;" src="@/assets/icon/dao_you_ji_tiao_zhuan.png" alt="">
            <a class="script-btn" :href="voiceguideParamConfig.script" 
              target="_blank" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;cursor: pointer;" 
            ></a>
          </span>
        </el-tooltip>
      

      <div class="preview" @click="handleShowPreview">
        <el-tooltip
          class="item"
          effect="dark"
          :enterable="false"
          content="预览"
          placement="top"
        >
          <img src="../../../assets/imgs/top-nav-icon/preview3.png" alt="" />
        </el-tooltip>
        <!-- <img src="../../../assets/imgs/top-nav-icon/preview2.png" alt="" /> -->
        <div
          :class="{ showPreview: isShowPreview }"
          @mouseleave="handleMouseleave"
          v-show="isShowPreview" >
          <div class="pc">
            <span>电脑端：</span>

            <router-link :to="{ name: 'FrontPC' }">
              <a class="skip" @click="handleSkip">跳转</a>
            </router-link>
            <a class="copy" @click="copyUrl(pcURL)"> 复制</a>
          </div>
          <div class="android">
            <span>手机端：</span>
            <div class="imageUpload">
              <image-upload
                :imgUrl="imageUrl"
                filedName="android" 
                @imgUploaded="imgUploadedHandle" 
                @imgRemoved="imgRemovedHandle">
              </image-upload>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="dialog">
        <el-dialog :visible.sync="dialogVisible" :modal-append-to-body="false" >
          <img width="100%" :src="imageUrl" alt />
        </el-dialog>
      </div> -->

      <!-- <img :src="accountImage" alt="" width="46px" /> -->
      
      <div class="right-c">
        <el-tooltip
          class="item"
          effect="dark"
          :enterable="false"
          content="退出登录"
          placement="top"
        >
          <img style="display: flex;width: 20px;height: 20px;border-radius: none;cursor: pointer;" src="@/assets/imgs/top-nav-icon/logout.png" @click="handleLogOut">
          <!-- <i
            class="el-icon-switch-button"
            style=" font-size: 27px;
              font-weight: 100;
              line-height: 50px;
              cursor: pointer;
              color: #555555;
            "
            @click="handleLogOut"
          ></i> -->
        </el-tooltip>
      </div>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import { mapState } from "vuex";
import { logout } from "../../../login/conf/commonFunc.js";
import ImageUpload from "../../../views/modelmanage/childecomponent/ImageUpload.vue";
export default {
  components: {
    ImageUpload,
  },
  name: "TopNav",
  data() {
    return {
      imageUrl: "",
      dialogVisible: false,
      row_id: null,

      show: true,
      datatime: "",
      accountName: "",
      accountImage: "",
      desId: "",
      origin_userInfo: {
        name: "",
      },
      projectName: "",
      pcURL: "",
      // 项目用户id
      user_id: "",
      isLogin: false,
      isShowPreview: false,
      currentNav: null,

      voiceguideParamConfig: {},
    };
  },
  created() {
    this.getVoiceguideParamConfig(); // 获取导游机脚�?
  
    this.accountName = this.userInfo.data.name;
    this.accountImage = this.userInfo.data.image || 'https://img0.baidu.com/it/u=974141393,2336151801&fm=253&app=120&size=w931&n=0&f=JPEG&fmt=auto?sec=1680282000&t=04e3a377907aeb8c62845075c31ba7db';
    this.desId = this.userInfo.data.destination_id;

    let center = "";
    switch(this.desId){
      case 64:
        center = "116.39742,39.909";
        break;
      case 80:
        center = "107.573704,30.691387";
      default:
        center = "116.404,39.915";
        break;
    };
    this.pcURL = window.location.origin + `/h5/#/?mapFirm=tdt&titile=语音导览&type=voice&destination_id=${this.desId}&center=${center}&style=pc`;
    
    console.log("this.pcURL-----------", this.pcURL);
  },
  watch: {
    userInfo: {
      deep: true,
      handler: function (newVal) {
        if (newVal) {
          this.origin_userInfo = newVal;
        }
      },
    },
  },
  computed: {
    ...mapState({ userInfo: state => state.userInfo }),
    totalUnread() {
      return this.$store.state.totalUnread;
    },
  },

  mounted() {
    let newName = JSON.parse(window.sessionStorage.userInfo).data.newName;
    let sys = JSON.parse(window.sessionStorage.userInfo).data.sys;
    if (newName) {
      this.projectName = newName;
    } else {
      this.projectName = sys;
    }
    console.log("userInfo-------", this.$store.userInfo);
    this.gettime();
    this.queryDataOfResource();

    // this.$bus.$on("isShowImg", (itemname) => {
    //   // console.log("itemname----------isShowImg----", itemname);
    //   this.dialogVisible = true;
    // });
  },
  methods: {
    getVoiceguideParamConfig() {
      this.$Request({
        method: "get",
        url: this.$Api.queryDataOfResource,
        params: {
          directory_code: "voiceguide_paramconfig",
        }
      }).then(res => {
        if(res.data.length > 0){
          this.voiceguideParamConfig = res.data[0];
        }
      })
    },
    // 删除图片 回显
    imgUploadedHandle(src,fieldName,success){
      console.log('imgUploadedHandle:>>>>>','===',fieldName,src);
      this.addDataOfResource(src);
      this.imageUrl = src;
      success()
    },
    // 删除图片
    imgRemovedHandle(fieldName,success){
      console.log('imgUploadedHandle:>>>>>','===',fieldName);
      this.deleteDataOfResource(this.row_id);
      this.imageUrl = '';
      success()
    },

    // 点击复制功能
    copyUrl(item) {
      console.log("点击复制功能-------", item);
      // 创建模拟 输入�?
      var cInput = document.createElement("input");
      cInput.value = item;
      document.body.appendChild(cInput);
      cInput.select(); // 选取文本框内�?

      // 执行浏览器复制命�?
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签�?
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand("copy");

      this.$message({
        type: "success",
        message: "复制成功",
      });
      // 复制成功后再将构造的标签 移除
      document.body.removeChild(cInput);
    },

    // 点击展示预览
    handleShowPreview() {
      // this.$bus.$emit("topNavDialog", this.isShowPreview);
      this.isShowPreview = !this.isShowPreview;
    },
    handleMouseleave() {
      this.isShowPreview = false;
    },
    // 点击跳转
    handleSkip() {
      this.$bus.$emit("defaultActive");
    },
    handleShowTitle() {
      this.$refs.title.style.left =
        this.$refs.title.style.left == "0px" ? "-200px" : "0px";
    },
    gettime() {
      setInterval(() => {
        let nowDate = new Date();
        let hour;
        let min;
        let sec;
        if (nowDate.getHours() < 10) {
          hour = "0" + nowDate.getHours();
        } else {
          hour = nowDate.getHours();
        }
        if (nowDate.getMinutes() < 10) {
          min = "0" + nowDate.getMinutes();
        } else {
          min = nowDate.getMinutes();
        }
        if (nowDate.getSeconds() < 10) {
          sec = "0" + nowDate.getSeconds();
        } else {
          sec = nowDate.getSeconds();
        }
        const hhmmss = `${hour}:${min}:${sec}`;
        this.datatime = `${nowDate.getFullYear()}/${
          nowDate.getMonth() + 1
        }/${nowDate.getDate()}\u0020\u0020${hhmmss}`;
      }, 1000);
    },
    handleLogOut() {
      logout();
    },
    goLogOut() {
      function getUrlParam(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
      }

      let url = window.document.location.href + "?" + paramStr;
      var login_page = getUrlParam("login_page");
      var paramStr = "";
      if (login_page && login_page != "") {
        paramStr += "login_page=" + login_page;
      }
      var username = getUrlParam("u");
      if (username && username != "") {
        if (paramStr) {
          paramStr += "&";
        }
        paramStr += "username=" + username;
      }
      var password = getUrlParam("p");
      if (password && password != "") {
        if (paramStr) {
          paramStr += "&";
        }
        paramStr += "password=" + password;
      }
      var logo = getUrlParam("l");
      if (logo && logo != "") {
        if (paramStr) {
          paramStr += "&";
        }
        paramStr += "logo=" + logo;
      }
      var title = getUrlParam("t");
      if (title && title != "") {
        if (paramStr) {
          paramStr += "&";
        }
        paramStr += "title=" + title;
      }
      let pathName = this.$route.href;
      let pos = url.indexOf(pathName);
      let redirectUrl = url.substring(0, pos);
      redirectUrl = redirectUrl.split("?")[0] + "?" + paramStr;
      window.localStorage.removeItem("logOut");
      window.location = this.$Api.logOut + "redirect_uri=" + redirectUrl;
    },
    // 检查本地localstorage存入的用户信�?
    checkLocalUserInfo() {
      // 获取本地的用户信�?
      let origin_userInfo = window.localStorage.getItem("origin_userInfo");
      // 检查本地登录原始用户信息是否存�?
      if (origin_userInfo) {
        this.origin_userInfo = JSON.parse(origin_userInfo);
        console.log("origin_userInfo", this.origin_userInfo);
        // 状态改为已登录
        this.isLogin = true;
        // 注册用户拿到Row_id
        // this.registUser();
      } else {
        // 没有用户信息 就去登录
        this.redirectToLogin();
      }
    },
    // 重定向到登录页面
    redirectToLogin(force = false) {
      function getUrlParam(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
      }

      let url = window.document.location.href;
      console.log("url------------------------", url);
      var login_page = getUrlParam("login_page");
      var paramStr = "";
      if (login_page && login_page != "") {
        paramStr += "login_page=" + login_page;
      }
      var username = getUrlParam("u");
      if (username && username != "") {
        if (paramStr) {
          paramStr += "&";
        }
        paramStr += "username=" + username;
      }
      var password = getUrlParam("p");
      if (password && password != "") {
        if (paramStr) {
          paramStr += "&";
        }
        paramStr += "password=" + password;
      }
      var logo = getUrlParam("l");
      if (logo && logo != "") {
        if (paramStr) {
          paramStr += "&";
        }
        paramStr += "logo=" + logo;
      }
      var title = getUrlParam("t");
      if (title && title != "") {
        if (paramStr) {
          paramStr += "&";
        }
        paramStr += "title=" + title;
      }
      let pathName = this.$route.href;
      let pos = url.indexOf(pathName);
      let redirectUrl = url.substring(0, pos); //encodeURIComponent(document.URL);
      redirectUrl = redirectUrl.split("?")[0] + "?" + paramStr;
      redirectUrl = encodeURIComponent(redirectUrl);
      let code = getUrlParam("code");
      if (!code || code == "" || force) {
        window.location =
          this.$Api.logIn +
          "client_id=appid&redirect_uri=" +
          redirectUrl +
          "&response_type=code&scope=read";
      } else {
        this.getUserInfo();
      }
    },
    // 通过 Url 里的code 获取用户信息
    getUserInfo() {
      function getUrlParam(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
      }

      let url = window.document.location.href;
      var login_page = getUrlParam("login_page");
      var paramStr = "";
      if (login_page && login_page != "") {
        paramStr += "login_page=" + login_page;
      }
      var username = getUrlParam("u");
      if (username && username != "") {
        if (paramStr) {
          paramStr += "&";
        }
        paramStr += "username=" + username;
      }
      var password = getUrlParam("p");
      if (password && password != "") {
        if (paramStr) {
          paramStr += "&";
        }
        paramStr += "password=" + password;
      }
      var logo = getUrlParam("l");
      if (logo && logo != "") {
        if (paramStr) {
          paramStr += "&";
        }
        paramStr += "logo=" + logo;
      }
      var title = getUrlParam("t");
      if (title && title != "") {
        if (paramStr) {
          paramStr += "&";
        }
        paramStr += "title=" + title;
      }
      let pathName = this.$route.href;
      let pos = url.indexOf(pathName);
      let redirectUrl = url.substring(0, pos);
      redirectUrl = redirectUrl.split("?")[0] + "?" + paramStr;
      redirectUrl = encodeURIComponent(redirectUrl);
      let sendFormData = new FormData();
      let code = getUrlParam("code");
      sendFormData.append("code", code);
      sendFormData.append("redirect_uri", redirectUrl);

      this.axios({
        method: "POST",
        url: this.$Api.getUserInfo,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        data: qs.stringify({
          code: code,
          redirect_uri: redirectUrl,
        }),
      }).then((response) => {
        if (response.data.data) {
          this.origin_userInfo = response.data.data;
          // 存入本地localStorage
          window.localStorage.setItem(
            "origin_userInfo",
            JSON.stringify(response.data.data)
          );
          // this.registUser();
          this.$ElMessage.success("登录成功");
        } else if (this.isLogin === false) {
          this.$ElMessage.warning("登录失败！正在重定向..");
          // 传入参数true强制跳转到登录页�?重新获取code
          this.redirectToLogin(true);
        }
      });
    },
    queryDataOfResource() {
      let params = {
        directory_code: "voiceguide_config",
      };
      this.$Request({
        method: "get",
        url: this.$Api.queryDataOfResource,
        params,
      })
        .then((result) => {
          this.imageUrl = result.data[0].image;
          this.row_id = result.data[0].row_id;
          console.log("result----------11111================", result);
          // console.log("this.imageUrl-------", this.imageUrl);
          console.log("this.row_id-----8888888--", this.row_id);
        })
        .catch((err) => {
          console.log("err-------", err);
        });
    },
    addDataOfResource(path) {
      let params = {
        directory_code: "voiceguide_config",
        data: {
          image: path,
        },
      };
      this.$Request({
        method: "post",
        url: this.$Api.addDataOfResource,
        data: params,
      })
        .then((result) => {
          console.log("result----------222222", result);
          // this.queryDataOfResource();
        })
        .catch((err) => {
          console.log("err-------", err);
        });
    },

    deleteDataOfResource(id) {
      // console.log("id-----------", id);
      let params = {
        data: { row_id: id },
        directory_code: "voiceguide_config",
      };
      this.$Request({
        method: "post",
        url: this.$Api.deleteDataOfResource,
        params,
      })
        .then((result) => {
          console.log("result----------deleteDataOfResource", result);
          // this.queryDataOfResource();
        })
        .catch((err) => {
          console.log("err-------", err);
        });
    },

    // 大屏展示
    handleShowFullScreen() {
      // this.$message('正在开发中.......');
      const url = this.$router.resolve({ name: "FullScreen" });
      console.log(url);
      window.open(url.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  z-index: 999;
  height: 50px;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f8f8;
  // box-shadow: 2px 0 2px 2px #bebebe;
  position: relative;
  border-bottom: 1px solid #d8dbe3;
  box-sizing: border-box;

  .header-title {
    padding-left: 30px;
    font-size: 17px;
    font-weight: bold;
    letter-spacing: 1px;
    color: #555;
    display: flex;
    align-items: center;
    img:hover {
      cursor: pointer;
    }
  }

  .header-admin {
    display: flex;
    align-items: center;
    padding-right: 30px;
    letter-spacing: 1px;
    color: #333;
    font-size: 12px;
    .preview {
      position: relative;
      // margin-right: 15px;
      cursor: pointer;

      img {
        display: flex;
        // width: 30px !important;
        width: 20px;
        height: 20px;
      }
    }
    .dialog{
      img{
        width: 100%;
      }
    }
    .showPreview {
      // width: 380px;
      // width: 270px;
      width: 230px;
      // height: 228px;
      // height: 190px;
      // height: 112px;
      height: 152px;
      // padding: 32px 48px;
      padding: 18px;
      box-sizing: border-box;
      background: #fff;
      position: absolute;
      border-radius: 4px;
      box-shadow: 0px 2px 21px 0px 
		    rgba(101, 101, 101, 0.11);
      top: 50px;
      left: 70%;
      transform: translateX(-50%);
      // margin-left: -190px;
      // margin-left: -140px;
      z-index: 999;
      font-size: 14px;
      &::before{
        position: absolute;
        top: -6px;
        left: 50%;
        content: "";
        display: inline-block;
        border: 6px solid #fff;
        border-bottom-color: transparent;
        border-left-color: transparent;
        transform: rotate(-45deg);
      }
      .pc {
        .skip,
        .copy {
          // width: 80px;
          // height: 35px;
          width: 62px;
	        height: 27px;
          text-align: center;
          display: inline-block;
          line-height: 27px;
          box-sizing: border-box;
          font-size: 14px;
          // border-radius: 4px;
          // background: linear-gradient(#d2d3dd, #66697d);
          background-color: #475cf0;
	        border-radius: 3px;
          color: #fff;
        }
        .copy {
          margin-left: 10px;
        }
      }
      .android {
        display: flex;
        margin-top: 10px;
        .upload {
          width: 80px;
          height: 35px;
          text-align: center;
          display: inline-block;
          line-height: 35px;
          box-sizing: border-box;
          border-radius: 4px;
          background-color: #3edd8a;
          color: #fff;
        }
        .imageUpload {
          // width: 40px !important;
	        // height: 40px !important;
          width: 80px !important;
	        height: 80px !important;
          :deep(.el-icon-delete),:deep(.el-icon-zoom-in){
            font-size: 14px;
          }
          :deep(.el-icon-delete){
            left: 12px;
          }
          :deep(.el-icon-zoom-in){
            margin-left: 14px !important;
          }
          /* margin-top: 16px; */
          /* padding-left: 60px; */
          :deep(.avatar-uploader) {
            // width: 100px !important;
            // height: 100px !important;
            // width: 40px !important;
	          // height: 40px !important;
            width: 80px !important;
	          height: 80px !important;
	          border-radius: 3px !important;
            .avatar {
              // width: 40px !important;
	            // height: 40px !important;
              width: 80px !important;
	          height: 80px !important;
              // width: 100px !important;
              // height: 100px !important;
	            border-radius: 3px;
            }
          }
          :deep(.file) {
            // width: 100px !important;
            // height: 100px !important;
            // width: 40px !important;
	          // height: 40px !important;
            width: 80px !important;
	          height: 80px !important;
            border-radius: 3px;
          }
          :deep(.avatar-uploader-icon) {
            // width: 100px !important;
            // height: 100px !important;
            // line-height: 100px !important;
            display: flex;
            justify-content: center;
            align-items: center;
            // width: 40px !important;
	          // height: 40px !important;
            width: 80px !important;
	          height: 80px !important;
            line-height: 40px;
            border: 1px dashed #888888;
            &::before{
              font-size: 11px;
              line-height: 40px;
            }
          }
        }
      }
    }
    img {
      width: 40px;
      // border-radius: 50%;
      // box-shadow: 0 0 4px 4px #000;
    }
    .data-time {
      margin-right: 12px;
      font-size: 14px;
      color: #333;
    }
  }
}
.user-info {
  margin: 0 14px;
}

.right-c {
  // margin: 0 10px;
  // width: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .bigscreen {
    width: 19px !important;
    border-radius: 0 !important;
  }
  .bell-img {
    width: 21px !important;
    height: 21px;
    margin-right: 5px;
  }
  &::before{
    display: flex;
    content: "";
    width: 1px;
    height: 21px;
    margin: 0 20px;
    background-color: #d8dbe3;
  }
}
.preview{
  display: flex;
  align-items: center;
  &::before{
    display: flex;
    content: "";
    width: 1px;
    height: 21px;
    margin: 0 20px;
    background-color: #d8dbe3;
  }
}
.transition-box {
  display: inline-block;
  width: 250px;
  // background: cadetblue;
  overflow: hidden;
  span {
    transition: all 0.3s ease-in-out;
    position: relative;
    left: 0px;
  }
}
:deep(.el-badge__content) {
  width: 18px;
  height: 18px;
  padding: 0px 5px;
  margin-right: 5px;
}
.el-tooltip.el-icon-switch-button {
  color: #fb6f49 !important;
  font-weight: 700 !important;
}
:deep(.el-dialog) {
  width: 30%;
}
:deep(.v-modal){
  display: none;
}
</style>

